import { InvalidateQueryFilters, useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteShow } from 'api/show'

export const useDeleteShow = () => {
    const queryClient = useQueryClient()

    const mutation = useMutation({
        mutationFn: deleteShow,
        onSuccess: () => {
            queryClient.invalidateQueries(['shows'] as InvalidateQueryFilters)
        },
    })

    return mutation
}
